import { thriveContent } from './thriveContent';
import { workflows } from './workflow';
import { getWorkflowState } from './workflowState';

export const youthProgram = {
  thriveContent: thriveContent,
  workflow: workflows,
  getWorkflowState,
};
